import React, { useState } from 'react';
import {
  VegaFlex,
  VegaButton,
  VegaInput,
  VegaTextarea,
  VegaModal,
  VegaForm,
  VegaFont,
  VegaIcon
} from '@heartlandone/vega-react';
import { VegaNotify } from '@heartlandone/vega';
import { _fetch } from 'Chore/Request';
import { PATH } from 'Chore/Apis';
import EmailUserSelector from '../EmailUserSelector/EmailUserSelector';

const { SEND_EMAIL_NOTIFICATION } = PATH;

const SendEmailNotificationPopup = ({
  isOpen = false,
  onClose = () => {},
  activityId,
  onSended,
  sentCount = 0,
  maxCount = 1,
}) => {
  const [receiverIds, setReceiverIds] = useState([]);
  const [options, setOptions] = useState([]);
  const [subject, setSubject] = useState('');
  const [comment, setComment] = useState('');
  const remaining = Math.max(0, maxCount - sentCount);
  const limitReached = sentCount >= maxCount;

  const isSendDisabled = receiverIds.length === 0 || !subject.trim() || limitReached;
  const [isSending, setIsSending] = useState(false);

  const handleSend = () => {
    if (isSending) {
      return;
    }
    if (isSendDisabled) {
      VegaNotify.open({
        type: 'warning',
        message: 'Please fill all required fields.'
      });
      return;
    }

    const selectedOptions = options.filter(item =>
      receiverIds.includes(item.key)
    );
    const groupIds = selectedOptions
      .filter(item => item.type === 'group')
      .map(item => item.key);
    const recipientEmailAddresses = selectedOptions
      .filter(item => item.type === 'user')
      .map(item => item.email);

    setIsSending(true);
    _fetch({
      api: SEND_EMAIL_NOTIFICATION(activityId),
      method: 'POST',
      data: {
        subject,
        comment,
        groupIds,
        recipientEmailAddresses
      }
    })
      .then(res => {
        if (res.code === 2200) {
          VegaNotify.open({
            type: 'success',
            message: 'The email has been sent.'
          });
          // removed legacy boolean dispatch; rely solely on increment action from parent
          setReceiverIds([]);
          setSubject('');
          setComment('');
          setOptions([]);
          onClose();
          onSended('success');
        } else {
          VegaNotify.open({
            type: 'error',
            message: res.message || 'The email could not be sent.'
          });
        }
      })
      .catch(() => {
        VegaNotify.open({
          type: 'error',
          message: 'The email could not be sent.'
        });
      })
      .finally(() => {
        setIsSending(false);
      });
  };

  return (
    <VegaModal size={560} backdrop="static" open={isOpen} onVegaClose={onClose}>
      <div slot="modal-title">Send Email Notification</div>
      <div slot="modal-content">
        <VegaForm>
          <VegaFlex direction="col" gap="size-24">
            <EmailUserSelector
              isOpen={isOpen}
              value={receiverIds}
              onChange={setReceiverIds}
              onOptionsChange={setOptions}
              label="To"
              placeholder=""
            />
            <VegaInput
              label="Subject"
              showClearIcon={false}
              required
              value={subject}
              onVegaChange={e => setSubject(e.target.value)}
            />
            <VegaTextarea
              label="Comment"
              value={comment}
              onVegaChange={e => setComment(e.target.value)}
            />
            <VegaFont color="text-secondary">
              <VegaIcon
                icon="fa-regular fa-circle-info"
                size="size-16"
                style={{ marginRight: '6px' }}
              />
              <span>{`Maximum Notification Sends: ${maxCount} Remaining: ${remaining}.`}</span>
            </VegaFont>
            <VegaFlex gap="size-12" justifyContent="end">
              <VegaButton variant="secondary" onVegaClick={onClose}>
                Cancel
              </VegaButton>
              <VegaButton
                disabled={isSendDisabled || isSending}
                loading={isSending}
                onVegaClick={handleSend}
              >
                { limitReached ? 'Limit Reached' : (isSending ? 'Sending...' : 'Send') }
              </VegaButton>
            </VegaFlex>
          </VegaFlex>
        </VegaForm>
      </div>
    </VegaModal>
  );
};

export default SendEmailNotificationPopup;